export default "__VITE_ASSET__BS6Ovshx__"